import { Organization } from '@/types/config/config.types';

import { CONFIG_URL, configApi } from './config.api';

export const organizationApi = configApi.injectEndpoints({
  endpoints: (builder) => ({
    createOrganization: builder.mutation<Organization, Partial<Organization>>({
      query: (organization) => ({
        url: `${CONFIG_URL}/organizations`,
        method: 'POST',
        body: organization,
      }),
    }),
    updateOrganization: builder.mutation<Organization, Organization>({
      query: (organization) => ({
        url: `${CONFIG_URL}/organizations/${organization.id}`,
        method: 'PUT',
        body: organization,
      }),
    }),
    deleteOrganization: builder.mutation<void, number>({
      query: (id) => ({
        url: `${CONFIG_URL}/organizations/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useCreateOrganizationMutation, useDeleteOrganizationMutation, useUpdateOrganizationMutation } =
  organizationApi;
